import React from 'react'

import LocationIcon, { Theme as LocationIconTheme } from 'components/base/Icon/LocationIcon'
import Title from 'components/base/Title'
import Paragraph, { Theme as ParagraphTheme } from 'components/base/Paragraph'

import PhoneNumber from './styles'

const ContactInfoDetails: React.FC = (): React.ReactElement => (
  <>
    <Title level={2}>Contact Info</Title>
    <LocationIcon theme={LocationIconTheme.phone} />
    <Paragraph theme={ParagraphTheme.large}>You can call us anytime</Paragraph>
    <PhoneNumber><span>1-800-211-8660</span></PhoneNumber>{/* The class-less span MUST be present in order for CallRail to work. https://bitbucket.org/flowerpress/insurancelounge.com/issues/607/callrail-integration-troubleshooting */}
  </>
)

export default ContactInfoDetails
